import {SimbixConnectActions} from './simbixActions'

const initialSimbixState = {
    connect: false, // наличие соединения
};

export const simbix = (state = { ...initialSimbixState}, action) => {
    switch (action.type) {
        case SimbixConnectActions.CONNECT_OK: 
            return {
                ...state,
                ...action.simbix,
                connect: true
            };
        case SimbixConnectActions.CONNECT_STARTED: 
        case SimbixConnectActions.CONNECT_ERROR: 
            return {
                ...state,
                connect: false
            };

        default:
            return state;
    }
};